import { render } from "./onboarding.vue?vue&type=template&id=9e6d31ac&lang=pug"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__